import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import * as yup from "yup";

import * as RHFAddressValidationRules from "@/utils/validation/schemas/address.RHF";

export const BPostAddressValidationSchema = yup.object({
    address: RHFAddressValidationRules.addressLine
});

export const OptionalBPostAddressValidationSchema = yup.object({
    address: RHFAddressValidationRules.addressLine.optional()
});

export type BPostAddressFieldValues = yup.InferType<
    typeof BPostAddressValidationSchema
>;

export type OptionalBPostAddressFieldValues = yup.InferType<
    typeof OptionalBPostAddressValidationSchema
>;

export type BPostFieldAddress = CloudCustomerAddress & {
    address: string;
    selected: boolean;
    isComplete: boolean;
};
